export const enum ConnectMode {
    ERROR = 'ERROR',
    DETAILS = 'DETAILS',
    INITIAL = 'INITIAL',
    SUCCESS = 'SUCCESS',
    SETTINGS = 'SETTINGS',
    NOT_AVAILABLE = 'NOT_AVAILABLE',
    INSTALLATION_ID = 'INSTALLATION_ID',
    LINKING_IN_PROGRESS = 'LINKING_IN_PROGRESS',
}

export const enum TileColors {
    'OFF' = 'color-grey',
    'ON' = 'color-secondary',
}
